// extracted by mini-css-extract-plugin
module.exports =  {"tableWrapper":"YKltl2W2CQfb3l9RdH3F"};